<template>
  <div v-if="isReady">
    <Panel :padding="[22, 24]">
      <div class="question-desc">
        <div>{{ currItem.question_description_obj[computedLang] }}</div>
        <slot></slot>
      </div>
      <div class="panel-content">
        <div class="panel-article">
          <div v-for="(item, index) in currItem.screen_text" :key="index">
            <div class="key-words" v-if="item.type == 'text'">{{ item.content }}</div>
            <img v-else-if="item.type == 'image'" :src="baseUrl + item.content + '?width=300'" alt="" />
          </div>
        </div>
        <div class="answer_result">
          <div>{{ $t('mark_answer') }}:</div>
          <strong>{{ currItem.useAnswer || $t('hsk_homework_no_answer') }}</strong>
          <div class="limit">{{ wordLength || 0 }}/50</div>
        </div>
        <div class="reference_answer">
          <div>{{ $t('hsk_reference_answer') }}</div>
          <p v-for="(item, index) in analysisText" :key="index">
            {{ item }}
          </p>
        </div>
        <AiSuggestScore :score="currItem.aiScores" />
      </div>
    </Panel>
  </div>
</template>

<script>
import { getAllWordsLength } from '@/utils/utils'
export default {
  name: 'CommonWritePaResult',
  props: {
    currItem: {
      type: Object,
      default: () => {},
    },
    baseUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  computed: {
    isReady() {
      return JSON.stringify(this.currItem) !== '{}'
    },
    computedLang() {
      return localStorage.getItem('language') || 'en'
    },
    analysisText() {
      return this.currItem.evaluate.standard_answer[0].split('\n')
    },
    wordLength() {
      return getAllWordsLength(this.currItem.useAnswer)
    },
  },
}
</script>

<style lang="scss" scoped>
.question-desc {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.panel-content {
  margin-left: 32px;
  margin-top: 12px;
  .panel-article {
    img {
      width: 160px;
      height: 105px;
      border-radius: 4px;
      margin-top: 10px;
      object-fit: contain;
    }
    .key-words {
      font-weight: 600;
      font-size: 16px;
      color: #2c2f46;
      margin-top: 8px;
    }
  }
  .answer_result {
    div {
      color: #faae56;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      margin-top: 24px;
      margin-bottom: 8px;
    }
    strong {
      font-weight: 600;
      font-size: 14px;
      color: #2c2f46;
    }
    .limit {
      font-weight: 600;
      font-size: 14px;
      color: #2c2f46;
      margin-top: 10px;
      text-align: right;
    }
  }
  .reference_answer {
    margin-top: 24px;
    div {
      color: #faae56;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      margin-top: 24px;
      margin-bottom: 8px;
    }
    p {
      font-size: 14px;
      color: #545961;
      line-height: 25px;
    }
  }
}
</style>
